import request from '../../services/request';

export const companyInfo = () => {
  return request({
    url: `/company/info`,
    method: 'GET',
  });
};

export function updateCompany(id, data) {
  return request({
    url: `/company/${id}`,
    method: 'PUT',
    data,
  });
}

// ----------------- Catalogs ----------------

export function catalogFaceModel() {
  return request({
    url: '/company/catalog/face-model',
    method: 'GET',
  });
}

export function catalogFaceDetector() {
  return request({
    url: '/company/catalog/face-detector',
    method: 'GET',
  });
}
